/**
 * Swedish
 */

import translation from "../../../../shared/translations/sv_SE";

export default {
  ...translation,
  DROPDOWN : {
    TOGGLE: "Välj antal",
  },
  HEADER : {
    LOGO : "<span>%name filmförmån</span>Digital underhållning"
  },
  FORM : {
    ...translation.FORM,
    HEADING    : "Kontrollera mailadress",
    INFO       : "När du har lagt din beställning skickas värdekoden till den mailadress du anger ovan. Månaden efter att du har lagt din beställning kommer du få ett löneavdrag baserat på din beställning, dvs. lägger du en beställning i september kommer du få ett löneavdrag i oktober.",
  },
  PRODUCT : {
    ...translation.PRODUCT,
    PCS: " st",
    PREVIOUS_PRICE: "(tidigare %price)",
    PLEASE_CHOOSE: "Välj antal",
    QTY_TITLE: "Hur många %title vill du hyra?",
    QTY_TITLE_FALLBACK: "Hur många filmer vill du hyra?"
  },
  CHECKOUT: {
    ...translation.CHECKOUT,
    HEADING: "Bekräfta köp"
  },
  REVIEW: {
    HEADING: "Summering",
  },
}
